import { Input } from "antd";
import React from "react";
import "./login.scss";
import login_img from "../../images/president_login_img.png";
import gatekeeper_logo from "../../images/getkeeper_logo.png";
import Title from "antd/es/skeleton/Title";
import Loading from "../common/Loading/loading";

const LoginComponent = (props) => {
  const { handleSubmit, handleLogin, validation, handelotp, loading } = props;

  const onChange = (text) => {
  };

  const sharedProps = {
    onChange,
  };

  return (
    <div className="login">
      <div className="login-img-left">
        <img src={login_img} alt="" />
      </div>
      <div className="login-right-content">
        <div className="login-right">
          <img
            src={gatekeeper_logo}
            alt="gatekeeper_logo"
            className="society-logo"
          />
          <h3 className="register-text">Login with Mobile Number & PIN</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className="login-form">
              <p>Mobile Number</p>
              <Input
                size="large"
                className="input-field"
                placeholder="Enter Mobile Number"
                name="phone_number"
                type="tel"
                onChange={handleLogin}
                onInput={(event) => {
                  event.target.value = event.target.value.replace(/\D/g, "");
                }}
                maxLength={10}
                prefix={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg"
                      alt="India Flag"
                      style={{ width: 20, height: 15, marginRight: 5 }}
                    />
                    <span>+91</span>
                  </span>
                }
              />
              {validation.phone_number && (
                <p
                  style={{
                    color: "red",
                    paddingBottom: "3px",
                    fontSize: "14px",
                  }}
                >
                  {validation.phone_number}
                </p>
              )}
            </div>

            <div className="login-form">
              <p>Enter PIN</p>
              <div className="enter-otp-main">
                <Title level={3}>With custom display character</Title>
                <Input.OTP
                  {...sharedProps}
                  length={4}
                  onChange={handelotp}
                  name="code"
                  type="number"
                  inputMode="numeric"
                  style={{
                    WebkitTextSecurity: "disc",
                  }}
                />
              </div>
              {validation.code && (
                <p
                  style={{
                    color: "red",
                    paddingBottom: "3px",
                    fontSize: "14px",
                  }}
                >
                  {validation.code}
                </p>
              )}
            </div>

            <button className="login-button" type="submit">
              {loading ? <Loading type="spinner" color="#fff" /> : "Log In"}
            </button>
          </form>

          <p className="login-last-text">
            Welcome back! Your community is just a step away. Secure, simple,
            and seamless—let's get started! 💛
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
